"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apis = require("../../../../@apis");
var _hooks = require("../../../../@hooks");
var _functions = require("../../../../@functions");
var _constants = require("../../../../@constants");
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var masks = {
  company: _constants.docMasks.cnpj,
  autonomous: _constants.docMasks.cpf
};

/**
 * @typedef UserType
 * @type {import("./index.jsx").UserType}
 */

/**
 * @typedef User
 * @type {import("./index.jsx").User}
 */

/**
 * @typedef StepProps
 * @type {import("./index.jsx").StepProps}
 */

/**
 * @param {StepProps} props
 */
function AccountType(props) {
  var _errorMsgs$userType;
  var user = props.user,
    goNext = props.goNext;
  var _useErrors = (0, _hooks.useErrors)(),
    errorMsgs = _useErrors.errorMsgs,
    addErrorMsg = _useErrors.addErrorMsg,
    cleanErrors = _useErrors.cleanErrors,
    disabled = _useErrors.disabled;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isCompany = _useState2[0],
    setIsCompany = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isAutonomous = _useState4[0],
    setIsAutonomous = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    identificationNumber = _useState6[0],
    setIdentificationNumber = _useState6[1];
  var userType = isCompany ? 'company' : isAutonomous ? 'autonomous' : undefined;
  var canGoNext = userType && identificationNumber && !disabled;

  /**
   * @param {UserType} type
   * @returns {(value: string) => Promise<boolean>}
   */
  var validateIdentificationNumber = function validateIdentificationNumber(type) {
    return /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(value) {
        var _yield$appcenterApi$c, customerExists;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _apis.appcenterApi.customer.exists(value);
            case 2:
              _yield$appcenterApi$c = _context.sent;
              customerExists = _yield$appcenterApi$c.data;
              cleanErrors('autonomous');
              cleanErrors('company');
              if (!(type === 'company')) {
                _context.next = 18;
                break;
              }
              if (_functions.validator.cnpj(value)) {
                _context.next = 12;
                break;
              }
              addErrorMsg(type, 'invalid-cnpj');
              return _context.abrupt("return", false);
            case 12:
              if (!customerExists) {
                _context.next = 15;
                break;
              }
              addErrorMsg(type, 'cnpj-already-used');
              return _context.abrupt("return", false);
            case 15:
              return _context.abrupt("return", true);
            case 18:
              if (!(type === 'autonomous')) {
                _context.next = 28;
                break;
              }
              if (_functions.validator.cpf(value)) {
                _context.next = 24;
                break;
              }
              addErrorMsg(type, 'invalid-cpf');
              return _context.abrupt("return", false);
            case 24:
              if (!customerExists) {
                _context.next = 27;
                break;
              }
              addErrorMsg(type, 'cpf-already-used');
              return _context.abrupt("return", false);
            case 27:
              return _context.abrupt("return", true);
            case 28:
              return _context.abrupt("return", false);
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleIsCompanyChange = function handleIsCompanyChange(evt) {
    var checked = evt.target.checked;
    setIsCompany(checked);
    if (checked) {
      setIsAutonomous(false);
      cleanErrors('autonomous');
      validateIdentificationNumber('company')(identificationNumber);
    }
  };

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleIsAutonomousChange = function handleIsAutonomousChange(evt) {
    var checked = evt.target.checked;
    setIsAutonomous(checked);
    if (checked) {
      setIsCompany(false);
      cleanErrors('company');
      validateIdentificationNumber('autonomous')(identificationNumber);
    }
  };

  /**
   * @param {UserType} type
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>) => void}
   **/
  var handleIdentificationNumberChange = function handleIdentificationNumberChange(type) {
    return /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(evt) {
        var value;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              value = evt.target.value;
              validateIdentificationNumber(type)(value);
              setIdentificationNumber(value);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  };
  var handleConfirmChanges = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var isValid, updates;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return validateIdentificationNumber(userType)(identificationNumber);
          case 2:
            isValid = _context3.sent;
            if (isValid) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return");
          case 5:
            /** @type {Partial<User>} */
            updates = {
              identificationNumber: identificationNumber,
              type: userType
            };
            goNext(_objectSpread(_objectSpread({}, user), updates));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleConfirmChanges() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: "Empresa (PJ)",
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      onChange: handleIsCompanyChange,
      checked: isCompany
    })
  }), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: "Aut\xF4nomo (PF)",
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      onChange: handleIsAutonomousChange,
      checked: isAutonomous
    })
  })), userType && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    alwaysShowMask: true,
    mask: masks[userType],
    onChange: handleIdentificationNumberChange(userType),
    value: identificationNumber
  }), ((_errorMsgs$userType = errorMsgs[userType]) === null || _errorMsgs$userType === void 0 ? void 0 : _errorMsgs$userType.length) > 0 && errorMsgs[userType].map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  })), canGoNext && /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleConfirmChanges,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Confirmar"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCheckDouble"
  })));
}
AccountType.propTypes = {
  user: _propTypes["default"].object.isRequired,
  goNext: _propTypes["default"].func.isRequired
};
var _default = AccountType;
exports["default"] = _default;
var errors = {
  'invalid-cpf': 'CPF inválido',
  'invalid-cnpj': 'CNPJ inválido',
  'cnpj-already-used': 'CNPJ já está em uso',
  'cpf-already-used': 'CPF já está em uso'
};